import React, { createContext, useState } from 'react';

export const DashboardSociogramContext = createContext();

export const DashboardSociogramContextProvider = ({ children }) => {
  const [course, setCourse] = useState({});
  const [student, setStudent] = useState({});

  const filterCourse = (organizationResults, courseId) => {
    const dataFilter = organizationResults?.filter(
      (course) => parseInt(course?.course?.id, 10) === parseInt(courseId, 10)
    )[0];
    setCourse(dataFilter);
  };

  const filterStudent = (studentsList, studentId) => {
    const studentFilter = studentsList?.filter(
      (student) => student?.enrollmentId === parseInt(studentId, 10)
    )[0];
    setStudent(studentFilter);
  };

  const popularityIndex = (student?.popularity * 100) / 5;
  const conflictivityIndex = (student?.conflictivity * 100) / 5;

  return (
    <DashboardSociogramContext.Provider
      value={{
        course,
        filterCourse,
        student,
        filterStudent,
        popularityIndex,
        conflictivityIndex,
      }}
    >
      {children}
    </DashboardSociogramContext.Provider>
  );
};
